import { defineStore } from 'pinia';
import { ReportAuctionsRequestFilter } from '@/types/report.type.ts';

export const useReportAuctionsFilterStore = defineStore('reports.report-auctions.filter', {
    state: (): ReportAuctionsRequestFilter => ({
        lot_status: [],
        brand_id: undefined,
        model_id: [],
        vin: '',
        lot_id: undefined,
        auction_from_date: '',
        auction_to_date: '',
        page: 1,
        sort: [{ start_date: 'desc' }],
    }),
});
